/**
 * AuthGuard Component
 * Protects routes that require authentication
 */

import React, { useEffect, useState } from 'react';

import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { useAppSelector, useStorefrontAuth } from '../../hooks';
import { selectIsAuthenticated, selectIsAuthLoading } from '../../store/slices';
import { routes } from '../../utils/routes';
import { Loader } from '../loader';

export const AuthGuard: React.FC = () => {
    const location = useLocation();
    const { checkExistingSession } = useStorefrontAuth();
    const isAuthenticated = useAppSelector(selectIsAuthenticated);
    const isLoading = useAppSelector(selectIsAuthLoading);
    const [hasChecked, setHasChecked] = useState(false);

    useEffect(() => {
        const checkAuth = async () => {
            if (!isAuthenticated) {
                await checkExistingSession();
            }
            setHasChecked(true);
        };

        checkAuth();
    }, [checkExistingSession, isAuthenticated]);

    // Still checking authentication
    if (!hasChecked || isLoading) {
        return <Loader fullPage pulse />;
    }

    // Not authenticated - redirect to welcome
    if (!isAuthenticated) {
        return <Navigate to={routes.WELCOME} state={{ from: location }} replace />;
    }

    // Authenticated - render protected content
    return <Outlet />;
};

export default AuthGuard;
